// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"_3VuHqX","justifyTabsContainer":"_2E-dDW","justifyTabContainer":"_10FJx_","compensator":"_2ZoslB","content":"_3KsA1O","shine-lines":"_14sLQo"};